export default "__VITE_ASSET__d433e050__"